exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_cardsContainer_2Xy4u4hDCDhcUQrKyUzpKW{\n  width: 100%;\n  overflow: auto;\n}\n\n.IA_title_1p9u9v3D4HaeOGFKFXKHNw {\n  color: \"#333333\";\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  line-clamp: 1;\n  -webkit-line-clamp: 1;\n  box-orient: vertical;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: -webkit-box;\n}", ""]);

// Exports
exports.locals = {
	"IA_cardsContainer": "IA_cardsContainer_2Xy4u4hDCDhcUQrKyUzpKW",
	"IA_title": "IA_title_1p9u9v3D4HaeOGFKFXKHNw"
};